import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faGoodreadsG,
  faRedditAlien,
  faPinterestP,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { SiX } from "react-icons/si";

import EmailForm from "../../../shared/forms/EmailForm";
import NewsletterSignupForm from "../forms/NewsletterSignupForm";
import { trackEvent } from "../helpers/analytics";
import "../styles/Contact.css";

const AUTHOR_EMAIL = "author@kennethlpowell.com";
const SOCIAL_PROFILES = [
  { name: "Facebook", platform: "facebook", url: "https://www.facebook.com/KennethLPowell", icon: faFacebook },
  { name: "Instagram", platform: "instagram", url: "https://www.instagram.com/kenneth_l_powell", icon: faInstagram },
  { name: "X", platform: "twitter", url: "https://x.com/KennethLPowell" },
  { name: "Goodreads", platform: "goodreads", url: "https://www.goodreads.com/author/show/21481075.Kenneth_L_Powell", icon: faGoodreadsG },
  { name: "Pinterest", platform: "pinterest", url: "https://www.pinterest.com/KennethLPowell/", icon: faPinterestP },
  { name: "Reddit", platform: "reddit", url: "https://www.reddit.com/user/AuthorKennethLPowell/", icon: faRedditAlien },
];

export default function Contact() {
  const [copyStatus, setCopyStatus] = useState("");

  async function handleCopyEmail() {
    try {
      if (!navigator.clipboard?.writeText) {
        throw new Error("Clipboard API is unavailable.");
      }

      await navigator.clipboard.writeText(AUTHOR_EMAIL);
      setCopyStatus("Email address copied to your clipboard.");
    } catch (error) {
      console.error("Unable to copy email address:", error);
      setCopyStatus(
        `Unable to copy automatically. The email address is ${AUTHOR_EMAIL}.`
      );
    }
  }

  return (
    <main className="contactSocial">
      <h1 className="contactPageTitle">Contact Kenneth L. Powell</h1>

      <section
        className="email-signup-section"
        id="newsletter"
        aria-labelledby="newsletter-heading"
      >
        <h2 id="newsletter-heading">Join the Rebellion</h2>

        <p>
          Get the full Dawn of Prophecy ebook free when you join my newsletter,
          along with new releases, lore, and updates. Prefer not to subscribe?
          The ebook is $0.99.
        </p>

        <NewsletterSignupForm />
      </section>

      <section
        className="emailFormDiv"
        aria-labelledby="contact-form-heading"
      >
        <h2 id="contact-form-heading">Send a Message</h2>
        <EmailForm />
      </section>

      <section
        className="emailAddressCopyDiv"
        aria-labelledby="attachments-heading"
      >
        <h2 id="attachments-heading">Sending Images or Attachments</h2>

        <p className="contactEmailCopyTxt">
          To send images or other attachments, copy the author&apos;s email
          address and paste it into your preferred email application.
        </p>

        <div className="contactEmailActions">
          <button
            type="button"
            className="contactEmailButton"
            onClick={handleCopyEmail}
            aria-label="Copy the author's email address"
          >
            <FontAwesomeIcon icon={faEnvelope} aria-hidden="true" />
            <span>Copy Email Address</span>
          </button>
        </div>

        {copyStatus && (
          <p
            className="contactEmailAddendum"
            role="status"
            aria-live="polite"
          >
            {copyStatus}
          </p>
        )}
      </section>

      <section className="socialMediaSection" aria-labelledby="social-heading">
        <h2 id="social-heading">Follow on Social Media</h2>

        <div className="socialMedia">
          {SOCIAL_PROFILES.map(profile => (
            <a
              key={profile.platform}
              href={profile.url}
              onClick={() => trackEvent("social_click", { destination_retailer: profile.platform })}
              target="_blank"
              rel="noopener noreferrer"
              className={profile.platform}
              aria-label={`Visit Kenneth L. Powell on ${profile.name}`}
              title={profile.name}
            >
              {profile.platform === "twitter" ? <SiX aria-hidden="true" /> : <FontAwesomeIcon icon={profile.icon} aria-hidden="true" />}
            </a>
          ))}
        </div>
      </section>
    </main>
  );
}
